module.exports = __webpack_public_path__ + "static/media/menu-close.69ceaaa1.svg";